import {Breakpoints, DrawerLimiter} from './types'

export function getCurrentTranslateY(element: HTMLDivElement) {
  return element.style.transform && element.style.transform !== 'none'
    ? parseFloat(element.style.transform.split(',')[1])
    : 0
}

export function setElementTransform(element: HTMLDivElement, value: number) {
  element.style.transform = `translate3d(0, ${value}px, 0)`
}

export function setOverlayOpacity(
  element: HTMLDivElement,
  y: number,
  min: number,
  max: number,
  minOpacity: number = 0.6,
) {
  let value = Math.floor((y / (min - max)) * 100)

  if (y > min || y < max) {
    element.style.opacity = '0%'
    return
  }
  const percentageOfOpen = 100 - value
  const percentageOfShadow = Math.floor(minOpacity * percentageOfOpen)
  if (percentageOfShadow > 0) {
    element.style.display = 'block'
  }

  element.style.opacity = `${percentageOfShadow}%`
}

export function getClosestBreakpoint(limiter: DrawerLimiter, breakpoints: Breakpoints[], offset: number): Breakpoints {
  let min = Infinity
  let breakpoint: Breakpoints
  for (const [bpName, bpValue] of Object.entries(limiter)) {
    if (!breakpoints.includes(bpName as Breakpoints)) {
      continue
    }
    const diff = Math.abs(offset - bpValue)
    if (diff < min) {
      breakpoint = bpName as Breakpoints
      min = diff
    }
  }

  return breakpoint
}

export function isBetweenBounds(value: number, maximum: number, minimum: number) {
  return minimum <= value && maximum >= value
}

export function isValidBreakpointsOptions(activeBreakpoints: Breakpoints[], ...breakpoints: Breakpoints[]) {
  for (const breakpoint of breakpoints) {
    if (!activeBreakpoints.includes(breakpoint)) {
      console.error(`Текущий набор активных breakpoints ${activeBreakpoints} не содержит ${breakpoint}`)
      return false
    }
  }
  return true
}
